<!-- 空布局 license by http://eleadmin.com -->
<template>
  <keep-alive :include="include" :exclude="exclude">
    <router-view />
  </keep-alive>
</template>

<script>
  export default {
    name: 'EleEmptyLayout',
    computed: {
      include() {
        return this.$store?.state?.theme?.keepAliveInclude ?? [];
      },
      exclude() {
        return this.$store?.state?.theme?.keepAliveExclude;
      }
    }
  };
</script>
